export default function FilmSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 479.92 91.18"
      className="w-64 max-h-7 2xl:max-h-8"
    >
      <path
        className="svg-text"
        fill="#131414"
        d="M0,33.85V21.75H9.68V12L24.8,8.65v13.1H37v12.1H24.8V55.62c0,2.22.71,2.83,2.92,2.83H37.6v12.7H24.19c-10.58,0-14.51-3.43-14.51-13.31v-24Z"
      />
      <path
        className="svg-text"
        fill="#131414"
        d="M42.94,71.15V20.74H56.86l1,6.35h1C62.3,22.76,67,19.23,74.7,19.23c8.06,0,13.41,3.83,17.24,9h1c3.93-5.14,9.88-9,18.75-9,13.1,0,20.36,9,20.36,21.27V71.15H116.94V44.84c0-8.37-2.32-12.5-9.88-12.5s-12,5.34-12,12.8v26H79.94V44.84c0-8.37-2.32-12.5-9.88-12.5s-12,5.54-12,13V71.15Z"
      />
      <path
        className="svg-text"
        fill="#131414"
        d="M138.41,71.15V20.74h13.91l1,6.35h1a19.3,19.3,0,0,1,16-7.66c13.1,0,20.56,9,20.56,21.27v4.24H175.81V42.62c0-6.76-3.33-10.28-10.08-10.28-7.56,0-12.2,5.54-12.2,13V71.15Z"
      />
      <path
        className="svg-text"
        fill="#131414"
        d="M191.3,20.74h16l8.57,38.11h1l11-38.11h18.75l11,38.11h1l8.57-38.11h16L268.83,71.15h-21L237.27,35.36,226.69,71.15h-21Z"
      />
      <path
        className="svg-text"
        fill="#131414"
        d="M298.22,32.77V20.67H308.4V15.08c0-9.88,3.93-13.31,14.51-13.31h16.34v12.7H326.44c-2.22,0-2.92.61-2.92,2.83v3.37h15.22v12.1H323.52V71.15H308.4V32.77Z"
      />
      <path
        className="svg-text"
        fill="#131414"
        d="M360.78,71.15H345.65V20.74h15.13Z"
      />
      <path
        className="svg-text"
        fill="#131414"
        d="M383.5,71.15H368.58V3.61H383.5Z"
      />
      <path
        className="svg-text"
        fill="#131414"
        d="M390.8,71.15V20.74h13.91l1,6.35h1c3.43-4.33,8.17-7.86,15.83-7.86,8.06,0,13.41,3.83,17.24,9h1c3.94-5.14,9.88-9,18.75-9,13.11,0,20.37,9,20.37,21.27V71.15H464.8V44.84c0-8.37-2.32-12.5-9.88-12.5s-12,5.34-12,12.8v26H427.8V44.84c0-8.37-2.32-12.5-9.88-12.5s-12,5.54-12,13V71.15Z"
      />
      <circle className="svg-text" fill="#131414" cx="353.22" cy="9" r="9" />
      <circle
        className="svg-dot"
        fill="#fc473c"
        cx="290.55"
        cy="61.44"
        r="11.34"
      />
    </svg>
  );
}
